import React from 'react';
import { connect } from 'react-redux';
import { Button, Icon } from '@salesforce/design-system-react';
import MilestoneConnectors from './MilestoneConnectors';

const MilestoneBuilder = (props) => {
    return (
        <div 
            className="slds-p-around_small" 
            style={{ color: 'white'}}
        >
            <div className="slds-grid">
                <div className="slds-size_11-of-12" />
                <div className="slds-size_1-of-12 absolute-align_absolute-center">
                    <Button
                        assistiveText={{ icon: 'close' }}
                        iconVariant="bare"
                        iconSize="large"
                        iconPosition="right"
                        variant="icon"
                        iconCategory="utility"
                        iconName="close"
                        onClick={() => props.setMilestoneOpen(false)}
                    />
                </div>
            </div>
            <div className="milestone-title slds-p-vertical_x-small"><a href="Milestones">{props.milestones["trigger"].title.charAt(0).toUpperCase() + props.milestones["trigger"].title.substring(1)}</a></div>
            <div 
                className="milestone-content slds-p-left_small"
                style={{ borderLeft: '1px dashed #014486' }}
            >{props.milestones["trigger"].content}</div>

            <MilestoneConnectors 
                connectors={props.trigger}
            />

            <div className="milestone-title slds-p-vertical_x-small"><a href="Milestones">{props.milestones["guide"].title.charAt(0).toUpperCase() + props.milestones["guide"].title.substring(1)}</a></div>
            <div 
                className="milestone-content slds-p-left_small"
                style={{ borderLeft: '1px dashed #014486' }}
            >{props.milestones["guide"].content}</div>

            <MilestoneConnectors 
                connectors={props.guide}
            />

            <div className="milestone-title slds-p-vertical_x-small"><a href="Milestones">{props.milestones["key"].title.charAt(0).toUpperCase() + props.milestones["key"].title.substring(1)}</a></div>
            <div 
                className="milestone-content slds-p-left_small"
                style={{ borderLeft: '1px dashed #014486' }}
            >{props.milestones["key"].content}</div>

            
            <MilestoneConnectors 
                connectors={props.keyVar}
            />
                

            <div className="milestone-title slds-p-vertical_x-small"><a href="Milestones">{props.milestones["crisis"].title.charAt(0).toUpperCase() + props.milestones["crisis"].title.substring(1)}</a></div>
            <div 
                className="milestone-content slds-p-left_small"
                style={{ borderLeft: '1px dashed #014486' }}
            >{props.milestones["crisis"].content}</div>

            
            <MilestoneConnectors 
                connectors={props.crisis}
            />
            
            <div className="milestone-title slds-p-vertical_x-small"><a href="Milestones">{props.milestones["triumph"].title.charAt(0).toUpperCase() + props.milestones["triumph"].title.substring(1)}</a></div>
            <div 
                className="milestone-content slds-p-left_small"
                style={{ borderLeft: '1px dashed #014486' }}
            >{props.milestones["triumph"].content}</div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    milestones: state.milestones,
    trigger: state.milestoneConnectors.trigger,
    guide: state.milestoneConnectors.guide,
    keyVar: state.milestoneConnectors.keyVar,
    crisis: state.milestoneConnectors.crisis,
});

export default connect(mapStateToProps)(MilestoneBuilder);
